




























import {Component, Prop, Vue} from 'vue-property-decorator';
import {mapGetters} from "vuex";

@Component({
    name: "Menu",
    computed:{
        ...mapGetters({
            user: 'user'
        })
    }
})
export default class Menu extends Vue {
    @Prop(Boolean) private readonly value!: boolean;

    get show(){
        return this.value
    }

    set show(val:boolean){
        this.$emit('input',val)
    }

    private signOuthandler(){
        this.$store.dispatch('signOut')
        this.show = false;
    }
}

